import { areArraysEqual } from "../../../components/process-design/cell/Utils";
import { getMatrixOfValue, isFormula } from "../../../utils/util";
import { hfInstance } from "../../Cells";
import { rangeToHfFormat } from "../CellsHelper";
const utils = (context) => {
  const { rootGetters, currentSheet, currentSheetId } = context;
  return {
    // when a single cell is copied and target is more than one cell data should be applied to full target range
    shouldDataExpand(contents) {
      const mainRange = rootGetters["cells/mainRange"]?.range;
      const isOneRow = contents.length === 1;
      const isOneColumn = contents[0].length === 1;
      const isSingleTarget = mainRange[0] === mainRange[2] && mainRange[1] === mainRange[3];
      return isOneRow && isOneColumn && !isSingleTarget;
    },
    getRefinedTargetRange(storedData, clipboardData) {
      const [startColumnIndex, startRowIndex] = rootGetters["cells/mainRange"].range;
      return this.shouldDataExpand(clipboardData)
        ? rootGetters["cells/mainRange"].range
        : [
            startColumnIndex,
            startRowIndex,
            startColumnIndex + clipboardData[0].length - 1,
            startRowIndex + clipboardData.length - 1,
          ];
    },
    // receives value sum(h1:h2) and a target range
    // returns a matrix with updated value for entire target range
    getRefinedRangeData(value, range, sourceRange) {
      let previousValue;
      if (!sourceRange) {
        previousValue = hfInstance.getCellSerialized({ sheet: currentSheetId, row: range[1], col: range[0] });
        sourceRange = [range[0], range[1], range[0], range[1]];
      }
      if (!(value instanceof Array)) {
        if (isFormula(value)) {
          hfInstance.setCellContents({ sheet: currentSheetId, row: sourceRange[1], col: sourceRange[0] }, null);
          hfInstance.setCellContents({ sheet: currentSheetId, row: sourceRange[1], col: sourceRange[0] }, value);
        }
        value = isFormula(value)
          ? hfInstance.getFillRangeData(
              rangeToHfFormat(currentSheet, sourceRange),
              rangeToHfFormat(currentSheet, range)
            )
          : getMatrixOfValue(range, value);
      }
      return value;
    },
    isCopiedFromKyra(storedData, clipboardData) {
      storedData = storedData.map((row) => row.map((item) => (item ?? "") + ""));
      clipboardData = clipboardData.map((row) => row.map((item) => (item ?? "") + ""));
      return areArraysEqual(storedData, clipboardData);
    },
    parseClipboardData(data) {
      if (typeof data !== "string") {
        data = String(data);
      }
      // Split data into rows
      const rows = [];
      const lines = data.split("\n");
      let currentRow = [];
      let inQuotedCell = false;
      let currentCell = "";

      lines.forEach((line) => {
        let cells = line.split("\t");
        cells.forEach((cell) => {
          if (inQuotedCell) {
            currentCell += "\n" + cell;
            if (cell.endsWith('"')) {
              inQuotedCell = false;
              currentRow.push(currentCell.slice(0, -1)); // Remove the closing quote
              currentCell = "";
            }
          } else if (cell.startsWith('"')) {
            if (cell.endsWith('"') && cell.length > 1) {
              currentRow.push(cell.slice(1, -1)); // Remove the enclosing quotes
            } else {
              inQuotedCell = true;
              currentCell = cell.slice(1); // Remove the opening quote
            }
          } else {
            currentRow.push(cell);
          }
        });
        if (!inQuotedCell) {
          rows.push(currentRow);
          currentRow = [];
        }
      });

      return rows;
    },
    convertToStringObject(data) {
      const result = [];
      for (const [key, innerList] of Object.entries(data)) {
        result.push(innerList.map((item) => (String(item).includes("\n") ? String(`"${item}"`) : item))); // Convert all items to strings
      }
      return result;
    },
  };
};
const main = (context) => {};

export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
